/**
 * Account-activation helpers for the admin teacher tables.
 *
 * The "Signed up" / "Signup Date" columns used to read `issignup` and
 * `signupdate`. Neither is a column on the User model (nor on the production
 * users table), so both were `undefined` for every user in the system — the
 * columns rendered "No" and "N/A" for everyone, always. Community Christian
 * School was reading that table while trying to work out who had been set up.
 *
 * `mustChangePassword` is the working equivalent: it is set true when an admin
 * creates the account (the holder only has a temporary password) and cleared
 * when they choose their own. So "has this teacher activated their account?"
 * is `!mustChangePassword`.
 */

/**
 * Has the teacher set their own password?
 * Returns null when unknown, so callers can render "—" rather than a wrong "No".
 */
export function hasActivated(teacher) {
  if (!teacher || teacher.mustChangePassword === undefined || teacher.mustChangePassword === null) {
    return null;
  }
  return !teacher.mustChangePassword;
}

export function activationLabel(teacher) {
  const v = hasActivated(teacher);
  if (v === null) return "—";
  return v ? "Yes" : "No";
}

/**
 * When the account was created. This is NOT an activation timestamp — we do not
 * record one — so callers should label it "Added On", never "Signup Date".
 */
export function addedOn(teacher) {
  const raw = teacher && (teacher.createdAt || teacher.created_at);
  if (!raw) return "N/A";
  const d = new Date(raw);
  return isNaN(d.getTime()) ? "N/A" : d.toLocaleString();
}
